module.exports = __webpack_public_path__ + "media/images/costumes/top/swiper-dress-1-79247df627cfed555bc1e89731435c5f.jpg";